import { render, staticRenderFns } from "./leave_edit.vue?vue&type=template&id=64d9f989&scoped=true"
import script from "./leave_edit.vue?vue&type=script&lang=js"
export * from "./leave_edit.vue?vue&type=script&lang=js"
import style0 from "./leave_edit.vue?vue&type=style&index=0&id=64d9f989&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d9f989",
  null
  
)

export default component.exports